import { useContext } from "react";
import { ViewContext } from "@/components/lib";
import Ximage from "@/images/twitter_logo_2.svg";
// import HudlImage from "@/images/hudl_logo.svg";
import Styles from "@/css/mainStyles";

export default function ShareModal({ playerName, twitter_id, hudl, setOpen }) {
  const viewContext = useContext<any>(ViewContext);
  const link = `${window.location.origin}/${playerName}`;

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(link);
      viewContext.notification.show("Link copied to clipboard", "success");
    } catch (error) {
      console.error(error);
      viewContext.notification.show(error.message, "error");
    }
  };

  const shareOnTwitter = () => {
    const url = encodeURIComponent(link);
    const twitterIntentUrl = `https://twitter.com/intent/tweet?url=${url}`;
    window.open(twitterIntentUrl, "_blank");
  };

  return (
    <div>
      <h2 className="text-lg md:text-2xl font-bold mb-2">Share the Profile</h2>
      <p className="text-sm md:text-lg text-gray-600 mb-4">
        Share this profile with your network.
      </p>
      <div className="flex gap-2 items-center justify-center mb-4">
        {/* {hudl && (
          <a
            href={`https://www.hudl.com/profile/` + hudl}
            target="_blank"
            rel="noreferrer"
          >
            <img src={HudlImage} alt="X" className="w-18" />
          </a>
        )} */}
        {twitter_id && (
          <button onClick={shareOnTwitter}>
            <img src={Ximage} alt="X" className="w-16" />
          </button>
        )}
      </div>

      <div className="flex gap-2 md:gap-4 mb-4">
        <input type="text" className={Styles.input} value={link} readOnly />
        <button
          type="button"
          onClick={copyLink}
          className={Styles.button2}
          disabled={!playerName}
        >
          Copy
        </button>
      </div>

      <button onClick={() => setOpen(false)} className={Styles.cancelButton}>
        Cancel
      </button>
    </div>
  );
}
